
export type DeleteProjectComment200 = {
  code?: string;
  message?: string;
  success?: boolean;
};
